import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  getDepartmentInfoFailed,
  getDepartmentInfoStart,
  getDepartmentInfoSuccess,
} from "../redux/getDepartmentInfo";
import { getDepartmentInfoApi } from "core/http/service/recruitment";
import { formRecruitmentUpdate } from "../redux/formInput";
import { updateFormSearchRecruitment } from "../redux/formSearch";

function* getDepartmentInfoWork() {
  try {
    const res = yield call(getDepartmentInfoApi);
    yield put({
      type: getDepartmentInfoSuccess.type,
    });

    yield put({
      type: formRecruitmentUpdate.type,
      payload: {
        departmentLevel1Code: res?.deptCodeLevel1,
        departmentLevel2Code: res?.deptCodeLevel2,
        departmentLevel3Code: res?.deptCodeLevel3,
      },
    });
    yield put({
      type: updateFormSearchRecruitment.type,
      payload: {
        currentDepartment:
          res?.deptCodeLevel3 || res?.deptCodeLevel2 || res?.deptCodeLevel1,
      },
    });
  } catch (error) {
    yield put({
      type: getDepartmentInfoFailed.type,
    });
  }
}

function* watchGetDepartmentInfo() {
  yield takeLatest(getDepartmentInfoStart.type, getDepartmentInfoWork);
}

export default function* getDepartmentInfoSaga() {
  yield all([watchGetDepartmentInfo()]);
}
